// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { type FC } from 'react';
import { useListAdvisors } from './use-advisors';
import {
  AppIcon,
  IconButton,
  SectionContainer,
  WrapperEffect,
} from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers';
import { AdvisorsTable } from './advisors-table';
import { CircularProgress, Tooltip } from '@mui/material';

export const AdvisorsContent: FC = () => {
  const { advisors, unshareInstitution, status, hasData, onRefresh } =
    useListAdvisors();

  return (
    <SectionContainer
      className="mt-8"
      title={
        <span className="flex items-center space-x-3">
          <AppIcon icon="Users" className="inline-block" size="xl" />
          <Translation i18nKey="aggregator.my-advisors" ns="aggregator" />
        </span>
      }
      testId="advisors-table-container"
      actions={
        onRefresh ? (
          status === 'fetching' ? (
            <CircularProgress size={20} data-testid="loading-spinner" />
          ) : (
            <Tooltip
              title={<Translation i18nKey="common.refresh" ns="common" />}
              placement="top"
            >
              <span>
                <IconButton
                  icon="RefreshTwoArrows"
                  variant="icon"
                  size="lg"
                  color={status === 'pending' ? 'disabled' : 'main'}
                  onClick={onRefresh}
                  data-testid="refresh-btn"
                  disabled={status === 'pending'}
                />
              </span>
            </Tooltip>
          )
        ) : undefined
      }
    >
      <WrapperEffect showIn={status !== 'pending' || hasData}>
        <AdvisorsTable data={advisors} onUnshareInstitution={unshareInstitution} />
      </WrapperEffect>
    </SectionContainer>
  );
};
